module.exports = [
  "backend.config",
  "DS",
  "$sce",
  function(backend, DS, $sce) {
    var summary = DS.defineResource({
      name: "payrollSummary",
      omit: [/^[$]/],
      idAttribute: "userId",
      useClass: false,
      relations: {
        hasMany: {
          payrollPaycheck: {
            // localField is for linking relations
            // user.comments -> array of comments of the user
            localField: "paychecks",
            // foreignKey is the "join" field
            // the name of the field on a comment that points to its parent user
            foreignKey: "userId"
          }
        }
      }
    });
    summary.find.before(function(id, opts = {}) {
      opts.endpoint = "/payroll/" + backend.enterprise.code;
      return [id, opts];
    });

    var currencyFormat = {
      CAD: new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency: "CAD"
      }),
      USD: new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency: "USD"
      })
    };
    var paycheck = DS.defineResource({
      name: "payrollPaycheck",
      omit: [/^[$]/],
      idAttribute: "id",
      useClass: false,
      computed: {
        $payPeriod: [
          "year",
          "weekNumber",
          function(year, weekNumber) {
            var start = moment(`${year}${weekNumber}`, "YYYYWW");
            var end = moment(start).add(6, "days");
            return `${start.format("MMM D")} - ${end.format("MMM D")}`;
          }
        ],
        $grossPay: [
          "paycheckTotal",
          "currency",
          function(paycheckTotal, currency) {
            return $sce.trustAsHtml(
              currencyFormat[currency]
                .format(paycheckTotal)
                .replace(/\.[0-9]+$/, function(tail) {
                  return `<span class="superscript">${tail}</span>`;
                })
            );
          }
        ],
        $netPay: [
          "paycheckTotal",
          "currency",
          function(paycheckTotal, currency) {
            return $sce.trustAsHtml(
              currencyFormat[currency]
                .format(paycheckTotal * 0.6)
                .replace(/\.[0-9]+$/, function(tail) {
                  return `<span class="superscript">${tail}</span>`;
                })
            );
          }
        ]
      },
      beforeInject: function(config, attrs) {
        if (Array.isArray(attrs)) {
          var beforeInject = paycheck.beforeInject.bind(this, config);
          attrs.forEach(beforeInject);
        } else {
          attrs.id = `${attrs.year}${attrs.weekNumber}`;
        }
      }
    });
    paycheck.find.before(function(id, opts = {}) {
      opts.endpoint =
        "/payroll/" +
        backend.enterprise.code +
        "/paychecks/" +
        backend.userdata.email +
        "/" +
        id.slice(0, 4) +
        "/" +
        id.slice(4, 6);
      return [id, opts];
    });
    paycheck.findAll.before(function(params, opts = {}) {
      opts.endpoint =
        "/payroll/" +
        backend.enterprise.code +
        "/paychecks/" +
        backend.userdata.email;
      return [params, opts];
    });

    function tranformT4(attrs) {
      return typeof attrs === "object"
        ? attrs
        : {
            year: attrs
          };
    }

    var t4 = DS.defineResource({
      name: "payrollT4",
      omit: [/^[$]/],
      idAttribute: "year",
      useClass: false,
      afterFindAll: function(config, data, cb) {
        DS.defaults.afterFindAll(config, data.map(tranformT4), cb);
      }
    });
    t4.find.before(function(id, opts = {}) {
      opts.endpoint =
        "/payroll/" + backend.enterprise.code + "/t4/" + backend.userdata.email;
      opts.url = opts.endpoint + "/" + id + ".jpg";
      return [id, opts];
    });
    t4.findAll.before(function(params, opts = {}) {
      opts.endpoint =
        "/payroll/" + backend.enterprise.code + "/t4/" + backend.userdata.email;
      return [params, opts];
    });

    return {
      Summary: summary,
      Paycheck: paycheck,
      T4: t4,
      getPayroll: function() {
        return Promise.all([
          summary.find(backend.userdata.email),
          paycheck.findAll(),
          t4.findAll()
        ]).catch(function(e) {
          console.error(e);
        });
      }
    };
  }
];



// WEBPACK FOOTER //
// ./src/api/js-data/api/payroll.js